import React, { Component } from 'react';
import { Switch } from 'antd';
import { CloseOutlined, CheckOutlined } from '@ant-design/icons';
import formDataSchema from '../../../../schema/user-list';
import Select2 from '../../../../components/FormComponent/select2';
import Inputlayer from '../../../../components/FormComponent/Input';
import { filter, formData, dissableFormData } from '../../../../schema/apppointment';
import networkList from '../../../../constants/networkList';
const {homepage} = networkList;
class User_List extends Component {
    onChange(checked) {
        console.log(`switch to ${checked}`);
    }
    render() {
        return (
            <div>
                <div className="row mb-2 mr-5">
                    <div className="col-12 pr-0">
                        <button className="btn btn-success text-capitalize float-right">add user</button>
                    </div>
                </div>
                <div className="card ml-5 mr-5 mb-5 card-table">
                    <div className="card-header bg8">
                        <div className="clearfix">
                            <div className="float-left pt-1">
                                User List
                            </div>
                            <div className=" row col-xl-4 float-right">
                                {formDataSchema.feilds
                                    .map((feild, key) => {
                                        if (feild.element === 'select2') {
                                            return (
                                                <React.Fragment key={key}>
                                                    <div
                                                        className={`${feild.className
                                                            ? feild.className
                                                            : 'col '} ${feild.name}`}
                                                        key={key}>
                                                        <p className="data-label text-white w-75 mb-1 pt-1 text-right pr-2">{feild.text2}</p>
                                                        <Select2
                                                            Queuedata={formData}
                                                            selectdata={feild}
                                                            {...this.props}
                                                            {...this.state}
                                                        /> {feild
                                                            .errors
                                                            .map((error, eKey) => {
                                                                return (
                                                                    <small key={eKey} className="form-text text-danger">{error.message}</small>
                                                                );
                                                            })}
                                                    </div>
                                                </React.Fragment>
                                            )
                                        }
                                    })}
                            </div>
                        </div>

                    </div>
                    <div className="financial-table table-responsive">
                        <table className="table table-hover table-bordered mb-0">
                            <thead>
                                <tr>
                                    <td className="text-capitalize">s.no</td>
                                    <td className="text-capitalize">user Name</td>
                                    <td className="text-capitalize">user ID</td>
                                    <td className="text-capitalize">Age</td>
                                    <td className="text-capitalize">Gender</td>
                                    <td className="text-capitalize">Phone Number</td>
                                    <td className="text-capitalize">Unit</td>
                                    <td className="text-capitalize">Role</td>
                                    <td className="text-capitalize">Status</td>
                                    <td className="text-capitalize">Action</td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>1</td>
                                    <td className="text-capitalize">Abhishek Chowdhury</td>
                                    <td className="text-uppercase">us123456</td>
                                    <td className="text-capitalize">28 Years</td>
                                    <td className="text-capitalize">Male</td>
                                    <td>+91 9876 543 210</td>
                                    <td className="text-capitalize">kondapur, KIMS</td>
                                    <td className="text-capitalize">Counsellor</td>
                                    <td><Switch defaultChecked onChange={this.onChange} /></td>
                                    <td><img src={homepage+"/assets/images/icons/edit.png"} alt="edit" title="edit" /></td>
                                </tr>
                                <tr>
                                <td>2</td>
                                    <td className="text-capitalize">Abhishek Chowdhury</td>
                                    <td className="text-uppercase">us123456</td>
                                    <td className="text-capitalize">28 Years</td>
                                    <td className="text-capitalize">Male</td>
                                    <td>+91 9876 543 210</td>
                                    <td className="text-capitalize">kondapur, KIMS</td>
                                    <td className="text-capitalize">Counsellor</td>
                                    <td><Switch defaultChecked onChange={this.onChange} /></td>
                                    <td><img src={homepage+"/assets/images/icons/edit.png"} alt="edit" title="edit" /></td>
                                </tr>
                                <tr>
                                <td>3</td>
                                    <td className="text-capitalize">Abhishek Chowdhury</td>
                                    <td className="text-uppercase">us123456</td>
                                    <td className="text-capitalize">28 Years</td>
                                    <td className="text-capitalize">Male</td>
                                    <td>+91 9876 543 210</td>
                                    <td className="text-capitalize">kondapur, KIMS</td>
                                    <td className="text-capitalize">Counsellor</td>
                                    <td><Switch defaultChecked onChange={this.onChange} /></td>
                                    <td><img src={homepage+"/assets/images/icons/edit.png"} alt="edit" title="edit" /></td>
                                </tr>
                                <tr>
                                <td>4</td>
                                    <td className="text-capitalize">Abhishek Chowdhury</td>
                                    <td className="text-uppercase">us123456</td>
                                    <td className="text-capitalize">28 Years</td>
                                    <td className="text-capitalize">Male</td>
                                    <td>+91 9876 543 210</td>
                                    <td className="text-capitalize">kondapur, KIMS</td>
                                    <td className="text-capitalize">Counsellor</td>
                                    <td><Switch defaultChecked onChange={this.onChange} /></td>
                                    <td><img src={homepage+"/assets/images/icons/edit.png"} alt="edit" title="edit" /></td>
                                </tr>
                                <tr>
                                <td>5</td>
                                    <td className="text-capitalize">Abhishek Chowdhury</td>
                                    <td className="text-uppercase">us123456</td>
                                    <td className="text-capitalize">28 Years</td>
                                    <td className="text-capitalize">Male</td>
                                    <td>+91 9876 543 210</td>
                                    <td className="text-capitalize">kondapur, KIMS</td>
                                    <td className="text-capitalize">Counsellor</td>
                                    <td><Switch defaultChecked onChange={this.onChange} /></td>
                                    <td><img src={homepage+"/assets/images/icons/edit.png"} alt="edit" title="edit" /></td>
                                </tr>
                                <tr>
                                <td>6</td>
                                    <td className="text-capitalize">Abhishek Chowdhury</td>
                                    <td className="text-uppercase">us123456</td>
                                    <td className="text-capitalize">28 Years</td>
                                    <td className="text-capitalize">Male</td>
                                    <td>+91 9876 543 210</td>
                                    <td className="text-capitalize">kondapur, KIMS</td>
                                    <td className="text-capitalize">Counsellor</td>
                                    <td><Switch defaultChecked onChange={this.onChange} /></td>
                                    <td><img src={homepage+"/assets/images/icons/edit.png"} alt="edit" title="edit" /></td>
                                </tr>
                                <tr>
                                <td>7</td>
                                    <td className="text-capitalize">Abhishek Chowdhury</td>
                                    <td className="text-uppercase">us123456</td>
                                    <td className="text-capitalize">28 Years</td>
                                    <td className="text-capitalize">Male</td>
                                    <td>+91 9876 543 210</td>
                                    <td className="text-capitalize">kondapur, KIMS</td>
                                    <td className="text-capitalize">Counsellor</td>
                                    <td><Switch defaultChecked onChange={this.onChange} /></td>
                                    <td><img src={homepage+"/assets/images/icons/edit.png"} alt="edit" title="edit" /></td>
                                </tr>
                                <tr>
                                <td>8</td>
                                    <td className="text-capitalize">Abhishek Chowdhury</td>
                                    <td className="text-uppercase">us123456</td>
                                    <td className="text-capitalize">28 Years</td>
                                    <td className="text-capitalize">Male</td>
                                    <td>+91 9876 543 210</td>
                                    <td className="text-capitalize">kondapur, KIMS</td>
                                    <td className="text-capitalize">Counsellor</td>
                                    <td><Switch defaultChecked onChange={this.onChange} /></td>
                                    <td><img src={homepage+"/assets/images/icons/edit.png"} alt="edit" title="edit" /></td>
                                </tr>
                                <tr>
                                <td>9</td>
                                    <td className="text-capitalize">Abhishek Chowdhury</td>
                                    <td className="text-uppercase">us123456</td>
                                    <td className="text-capitalize">28 Years</td>
                                    <td className="text-capitalize">Male</td>
                                    <td>+91 9876 543 210</td>
                                    <td className="text-capitalize">kondapur, KIMS</td>
                                    <td className="text-capitalize">Counsellor</td>
                                    <td><Switch defaultChecked onChange={this.onChange} /></td>
                                    <td><img src={homepage+"/assets/images/icons/edit.png"} alt="edit" title="edit" /></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        )
    }
}

export default User_List;